<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="false"
    :showCancelBtn="false"
    class="history-reward"
    width="70%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
    @opened="handleOpen"
    top="5vh"
  >
    <template slot="title">
      {{ title }}
    </template>

    <tg-layout ref="layout" :headerHeight="100">
      <template slot="header" >
        <el-row :gutter="10" type="flex" justify="start" align="middle" style="flex-wrap: wrap;">
          <template v-for="(p, i) in third_party">
            <tg-button
              :key="i"
              round
              border
              hoverBorderOnly
              theme="primary"
              :active-gradient="p == reward.source_type"
              @click.native="toggleReward(p)"
            >
              {{ $t("component.label.source_type." + p) }}
              <template v-if="reward.isReal && !reward.isReal[p]"> ({{ $t("enum.half") }}) </template>
            </tg-button>
          </template>
        </el-row>
        <tg-amount-bar
          ref="amount"
          :columns="currentAmountColumns"
          :row="amountData"
        ></tg-amount-bar>
      </template>
      <tg-table
        ref="table"
        :columns="currentColumns"
        :proxy="proxy"
        align="center"
        :fit="true"
        showPagination
        showSummary
        :summary-method="parseSummary"
        @on-loaded="handleLoaded"
      >
        <template slot="betId" slot-scope="scope">
          <tg-bet-id :row="scope.row"></tg-bet-id>
        </template>
        <template slot="game_name" slot-scope="scope">
          <tg-game-name :row="scope.row"></tg-game-name>
        </template>
        <template slot="userfullname" slot-scope="scope">
          <tg-user-full-name
            :row="scope.row"
            :column="scope.column"
          ></tg-user-full-name>
        </template>
        <template slot="cell" slot-scope="scope">
          <span
            :class="{
              'text-red': scope.value < 0,
              'text-green': scope.value > 0,
            }"
            >{{ scope.formated }}</span
          >
        </template>
      </tg-table>
    </tg-layout>
  </tg-dialog>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgBetId from "@/components/slot/TgBetId";
import TgGameName from "@/components/slot/TgGameName";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog.vue";

import { summary } from "@/utils/table";
import apis from "@/apis";
const api = apis.accounts.reward;

import _ from "lodash";

export default {
  inheritAttrs: false,
  components: {
    TgLayout,
    TgTable,
    TgAmountBar,
    TgUserFullName,
    TgBetId,
    TgGameName,
    TgButton,
    TgDialog,
  },
  // provide() {
  //   return {
  //     container: this.$el,
  //   };
  // },
  data() {
    return {
      third_party: [],
      columns: [],
      
      tg_columns: {
        directpushColumns: [],
        unassignTeamColumns: [],
        assignTeamColumns: [],
      },
      third_party_columns: {
        directpushColumns: [],
        unassignTeamColumns: [],
        assignTeamColumns: [],
      },
      amountColumns: [],
      amountData: {},
      proxy: api.getData,
      visible: false,
      source_type:""
    };
  },
  props: {
    reward: Object,
  },
  computed: {
    title() {
      return this.reward ? this.reward.title : "";
    },
    currentColumns() {
      let reward = this.reward;
      let columns = [];
      let type = !this.source_type ? this.reward.source_type : this.source_type;
      let isReal = this.reward.isReal && this.reward.isReal[type];

      let target = type == 'tg' ? {...this.tg_columns} : {...this.third_party_columns};

      if (reward.type == 1) {
        columns = [...target.directpushColumns];
      } else {
        if (reward.status == 2) {
          columns = [...target.assignTeamColumns];
        } else if (reward.status == 4) {
          columns = [...target.unassignTeamColumns];
        }
      }

      columns = JSON.parse(JSON.stringify(columns));

      let i = columns.findIndex(x => x.name == 'reward');
      if (!isReal && columns[i]) {
        if (!columns[i].langKey.includes('half')) {
          columns[i].langKey += '.half';
        }
      }
      
      return columns;
    },
    currentAmountColumns() {
      if (this.currentColumns.length == 0) {
        return [];
      }
      
      let amountColumns = this.currentColumns
        .slice(-5)
        .map((x) => {
          return { ...x };
        })
        .slice(0, -1);
      amountColumns[3].name = "reward";

      

      if (this.reward.type == 2) {
        amountColumns = amountColumns.slice(-1);
      }
      return amountColumns;
    },
  },
  created() {
    this.source_type = this.reward.source_type;

    api.getColumns().then((response) => {
      let collection = _.cloneDeep(response.data);

      this.tg_columns = _.cloneDeep(response.data);

      // for(let k in collection) {
      //   let i = collection[k].findIndex(x => x.name == 'reward');
        
      //   if (i > -1) {
      //     collection[k][i].langKey += '.half';
      //   }
      // }
      
      this.third_party_columns = {...collection};
    });

    let array = ['tg'];
    this.thirdParties.forEach(element => {
      array.push(element.platform);
    });
    this.third_party = array;
    // apis.getThirdPartys().then((response) => {
    //   if (response.retcode == 0) {
    //     let array = ['tg'];
    //     response.data.forEach(element => {
    //       array.push(element.platform);
    //     });
    //     this.third_party = array;
    //   }
    // });
  },
  methods: {
    handleOpen() {
      this.$refs.table.doLayout();
      this.$refs.table.init(this.reward);
    },
    toggleReward(third_party) {
      let request = this.reward;
      this.source_type = third_party;
      request.source_type = third_party;
      this.$nextTick(() => {
        this.$refs.table.init(request);
      });
    },
    parseSummary({ data }) {
      return summary(
        this.currentColumns,
        data,
        this.$t("component.table.summary"),
        4
      );
    },
    handleLoaded(response) {
      if (response.amount_data && !("length" in response.amount_data)) {
        this.amountData = response.amount_data;
      }
    },
    showDialog() {
      this.visible = true;
    },
  },
};
</script>
